export const SIGN_UP_STATES = {
  newMarketUser: 'new_market_user',
  emailIsUnconfirmed: 'email_is_unconfirmed',
  phoneNumberIsMissing: 'phone_number_is_missing',
  phoneNumberTryAgain: 'phone_number_try_again',
  phoneNumberIsUnconfirmed: 'phone_number_is_unconfirmed',
  accountFullyConfirmed: 'account_fully_confirmed',
};
